/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import * as styled from 'styled-components';
import { normalize } from 'styled-normalize';

export default styled.createGlobalStyle`
  ${normalize}

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
    // padding: 2px;
  }

  .content-wrap {
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 20px auto;
  }

  #map-wrap {
    position: relative;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    height: 500px;
    // border: 1px solid #306231;
  }

  @media (max-width: 500px) {
    #map-wrap {
      height: 100vw;
    }
  }

  .mapContainer {
    width: 100%;
    height: 100%;
  }

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: #000;
    border-left: 4px solid #e12827;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  header p {
    padding: 2px 10px 5px 10px;
  }

  .zoom-hint {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }

  @media (max-width: 500px) {
    .zoom-hint {
      font-size: 12px;
    }
  }

  // bio
  .bio-wrap {
    margin-top: 20px;
  }

  p {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    padding: 0 10px 0 20px;
  }

  .siteHeading {
    font-family: 'Ubuntu', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #000;
    border-left: 4px solid #e12827;
    padding-left: 16px;
  }

  .source {
    font-size: 14px;
    line-height: 18px;
    color: #aaa;
    padding-left: 20px;
    font-style: italic;
  }

  .siteType {
    font-size: 18px;
    text-transform: uppercase;
    color: #1a2d19;
    padding-left: 20px;
    // padding-bottom: 20px;
  }

  .siteLink {
    padding-left: 20px;
  }

  .gallery-wrap {
    margin-top: 40px;
  }

  .image-wrap {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
  }

  .galleryImage {
    width: 100%;
    height: auto;
  }

  .image-credit {
    padding-right: 10px;
    padding-top: 3px;
    font-size: 12px;
    line-height: 13px;
    color: #999;
    width: 50%;
    text-align: right;
  }

  .image-count {
    padding-left: 10px;
    padding-top: 3px;
    font-size: 12px;
    line-height: 13px;
    color: #999;
    width: 50%;
    text-align: left;
  }

  .image-text-bot {
    display: flex;
    flex-direction: row;
  }

  @media (max-width: 500px) {
    .image-text-bot {
      flex-direction: column;
    }

    .image-count {
      width: 100%;
    }

    .image-credit {
      padding-left: 10px;
      width: 100%;
      padding-right: 2px;
      text-align: left;
    }
  }

  // map tool tips
  .mapboxgl-popup-content {
    background-color: #333;
  }

  .mapboxgl-popup-tip {
    display: none !important;
  }

  .mapboxgl-popup-close-button {
    color: white !important;
  }

  .toolWrap {
    width: 280px;
    height: 120px;
    display: flex;
  }

  .toolImageWrap {
    width: 120px;
    padding: 5px;
  }

  .toolTextWrap {
    width: 168px;
  }

  .toolLocation {
    font-size: 18px;
    line-height: 24px;
    font-family: 'Ubuntu';
    color: #f0f0f0;
    padding: 5px 10px 2px 10px;
    font-weight: 600;
  }

  .toolType {
    font-size: 18px;
    line-height: 22px;
    text-transform: uppercase;
    font-family: 'Raleway', sans-serif;
    color: #ffbc21;
    padding-left: 10px;
  }

  .readMore {
    font-size: 12px;
    line-height: 18px;
    color: #aaa;
    padding-left: 10px;
    font-style: italic;
  }

  // thumbs css
  .thumbs-container {
    display: flex;
    width: 100%;
    background-color: #efefef;
    margin-top: 20px;
    height: 200px;
  }

  .thumbs-wrap {
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    width: calc(100% - 100px);
    height: 200px;
  }

  .nav {
    height: 180px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 45px;
    font-weight: 900;
    cursor: pointer;
    color: #233622;
  }

  .card {
    position: relative;
    display: block;
    width: 180px;
    height: 180px;
    border: 1px solid #efefef;
    flex-grow: 1;
    flex-shrink: 0;
    margin: 5px;
    cursor: grab;
  }

  .card img,
  .card div {
    pointer-events: none;
  }

  .year-text {
    position: absolute;
    top: 5px;
    left: 10px;
    color: #f0f0f0;
    background-color: #000;
    padding: 2px 5px;
  }

  // footer
  footer {
    width: 100%;
    height: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #999;
    padding-top: 20px;
  }

  // markers
  .mapboxgl-popup {
    z-index: 1000;
  }

  .mapboxgl-marker {
    z-index: 1;
  }

  .mapboxgl-marker.active {
    z-index: 10;
  }
`;
